import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { BrowserView } from 'react-device-detect';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';

export const PrivacyPolicy = () => {
    const renderContent = () => (
        <Flex className={'privacy-policy'}>
            <h1>Privacy and Cookie Policy</h1>
            <br />
            <p>Information We Collect</p>
            <p>The information we collect depends on what Services you use and how you use them.</p>
            <p>A. Information You Give Us Directly</p>
            <p>
                <br />
            </p>
            <p>
                We collect information that you give us directly, such as when you create a
                STREAMSIX Account, set up security questions, make purchases, or contact STREAMSIX
                Help.
            </p>
            <p>
                <br />
            </p>
            <p>We collect information that you provide us, such as:</p>
            <p>
                <br />
            </p>
            <p>
                Your STREAMSIX Account information, including your email address, username, real
                name, country, date of birth, telephone number and password;
            </p>
            <p>Security questions and answers;</p>
            <p>Information you provide in response to surveys about our Services; and</p>
            <p>
                Information you provide when seeking help from us, such as your name, telephone
                number, and records (including call recordings) of the issues you experience.
            </p>

            <p>
                <br />
            </p>
            <p>B. Information You Provide When Playing Online</p>
            <p>
                <br />
            </p>
            <p>
                When you play online, we may collect information about your gaming profile, your
                gameplay, or your use of social features.
            </p>
            <p>
                <br />
            </p>
            <p>
                When you participate in social features such as chat, any audio, visual, and/or
                electronic information that you disclose may be read, copied, collected, or used by
                other players, and may become publicly available. Please make sure your privacy
                settings reflect your preferences.
            </p>
            <p>
                <br />
            </p>
            <p>
                When you participate in online multiplayer games, your in-game profile information,
                gameplay, and statistics are visible and may be replayed to other STREAMSIX players
                and at live STREAMSIX or partner events.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>C. Other Information We Collect When You Use Our Services</p>
            <p>
                <br />
            </p>
            <p>
                We may collect other information when you use our Services, such as information
                about your device, hardware and software information, IP address, or browser
                information.
            </p>
            <p>
                <br />
            </p>
            <p>
                We may collect other information automatically when you use our Services, such as:
            </p>
            <p>
                <br />
            </p>
            <p>IP address;</p>
            <p>
                Information about your device, hardware, and software, such as your hardware
                identifiers, mobile device identifiers (like Apple Identifier for Advertising
                [IDFA], or Android Advertising ID [AAID]), platform type, settings and components,
                STREAMSIX software and updates you have installed, and the presence of required
                plugins;
            </p>
            <p>Approximate geolocation data (derived from IP or device settings);</p>
            <p>Browser information, including your browser type and the language preference;</p>
            <p>
                Referring and exit pages, including pages viewed and other interactions with web
                content;
            </p>
            <p>
                Details about what STREAMSIX games or Services you purchase or obtain, and your use
                of them;
            </p>
            <p>In-app purchases made in STREAMSIX developed games</p>
            <p>
                Device event information, including crash reports, request and referral URLs, and
                system activity details (e.g., whether you encountered an error playing our games or
                lost Internet access); and
            </p>
            <p>
                Other information (such as your likeness) that you may provide as part of your
                participation in live events.
            </p>
            <p>
                We also may collect and store information locally on your device, using mechanisms
                like cookies, browser web storage (including HTML 5), and application data caches.
            </p>
            <p>Your information may be processed through Google Firebase and Google analytics.</p>

            <p>
                <br />
            </p>
            <p>D. Information Provided to Us by Third Parties</p>
            <p>
                <br />
            </p>
            <p>
                We may receive information about you from third parties, mobile platforms, or
                third-party authenticators that you use to sign in to our Services.
            </p>
            <p>
                <br />
            </p>
            <p>
                We may receive information about you contained in third-party user accounts when you
                use STREAMSIX online Services on or through third-party gaming platforms, such as
                those listed below. This information is provided to STREAMSIX as part of
                establishing or linking a STREAMSIX Account, which is necessary to access
                <span>  </span>and engage with STREAMSIX interactive content (such as games and
                leaderboards and other STREAMSIX’s “Online Services”). Your use of STREAMSIX Online
                Services through these third-parties indicates your agreement for the transfer of
                this information. Examples of information we receive are provided below. We never
                receive your credit card number or other financial information from these
                third-parties as part of establishing or linking a STREAMSIX Account.
            </p>
            <p>
                <br />
            </p>
            <p>
                Social Gaming Platforms. When you use third-party social gaming platforms (such as
                Discord or Twitch) and link your STREAMSIX account, we will receive information
                associated with your account on those platforms. Please review the notices presented
                to you when linking your accounts for details on the information STREAMSIX receives.
            </p>
            <p>
                <br />
            </p>
            <p>
                Mobile Platforms. If you play or purchase our games on your mobile device or tablet,
                we receive information about you from the app stores and other mobile platform
                providers. This information may include your username or device ID and the fact that
                you made a purchase, as applicable, but does not include any financial information.
                Some of our mobile platforms may send information to us that you authorize them to
                provide. Our mobile games also may request additional personal information from you,
                such as push notification tokens, your device's specific location, or contact list,
                and we will collect this information only if you give us your consent.
            </p>
            <p>
                <br />
            </p>
            <p>Other Third Parties</p>
            <p>
                <br />
            </p>
            <p>
                We may receive information from other third parties, like Facebook or Apple Game
                Center, when you use these services with our games. We may also receive information
                about you when other players choose to share their contact lists with us or from
                publicly-available websites.
            </p>
            <p>
                <br />
            </p>
            <p>E. Categories of Personal Information Processed</p>
            <p>
                <br />
            </p>
            <p>
                Depending on your use of our Services, the following categories of personal
                information may have been collected, shared, sold, or disclosed in the preceding 12
                months (as these processing activities are defined under applicable privacy laws):
            </p>
            <p>
                <br />
            </p>
            <p>
                Identifiers; such as a real name, user name, account name, email, online
                identifiers, device identifiers, IP address, or mobile device identifiers;
            </p>
            <p>
                Characteristics of Protected Classifications under state or federal law; such as age
                or gender;
            </p>
            <p>
                Commercial Information; such as products or services interaction and purchase
                history;
            </p>
            <p>
                Approximate (coarse) geolocation data; such as location data derived from IP address
                or device settings;
            </p>
            <p>
                Activity<span>  </span>information; such as when you play our games, play certain
                multiplayer modes, use chat features, or participate in competitive game modes or
                live events;
            </p>
            <p>Inferences; such as consumer preferences drawn from the above.</p>
            <p>We may collect additional information, such as:</p>
            <p>
                If you are the recipient of a contest or sweepstakes prize that requires tax
                reporting, we may collect identifiers associated with your government-issued
                documents (such as a social security number).
            </p>
            <p>
                If you participate in our competitive gaming events, we may collect identifiers
                associated with your government-issued documents (such as a passport number),
                financial information (such as bank accounts), and health-related information.
            </p>
            <p>
                If you participate in our user experience research, we may collect financial
                information (such as bank accounts), health-related information and video footage of
                your gameplay, as well as your recorded image throughout the session.
            </p>

            <p>
                <br />
            </p>
            <p>F. Legal Basis for Processing</p>
            <p>
                <br />
            </p>
            <p>
                Depending on where you reside, we may rely on different legal bases to process your
                information. More information can be found in our Terms &amp; Conditions found at
                <a href="/terms-and-conditions"> streamsix.com/terms-and-conditions</a>.
            </p>
            <p>
                <br />
            </p>
            <p>
                Our legal basis for processing your personal information varies depending on the
                type of information we collect and the context in which we collect it as well as on
                your country of residence, as indicated when you are setting up your STREAMSIX
                account or, when not signed into a STREAMSIX account, your location as determined by
                your IP address and/or your device registration country.
            </p>
            <p>
                <br />
            </p>
            <p>
                If you are a resident of the European Economic Area or of a jurisdiction where
                similar legal requirements may apply such as Brazil, Switzerland, and the United
                Kingdom, we rely on a number of legal bases to process information about you. We
                will process information about you where we have your consent, where we have a
                legitimate interest to do so, where the processing is necessary for the performance
                of a contract with you, and/or where we have a legal obligation to process your
                information. For example, we typically rely on:
            </p>
            <p>
                <br />
            </p>
            <p>
                consent when placing cookies on your device on the web (through our cookie consent
                manager) to send you email marketing, or to deliver third party targeted advertising
                to you on our Services;
            </p>
            <p>
                our legitimate interests to process your information when providing you with
                customer service support, to serve targeted marketing of our Services, for fraud
                prevention and security purposes; and
            </p>
            <p>
                on contractual necessity to process information when you create a STREAMSIX Account
                to enable us to provide you with our Services.
            </p>

            <p>
                <br />
            </p>
            <p>2. How We Collect Information</p>
            <p>
                We use various technologies to deliver and measure the effectiveness of our
                Services, to serve advertisements, and to enhance your player experience. These
                technologies include cookies and similar technologies, as well as analytics,
                advertising, anti-cheat, and anti-fraud technologies.
            </p>
            <p>
                <br />
            </p>
            <p>
                We and third parties use technologies described below to collect information to
                deliver our Services.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>A. Cookies and Similar Technologies</p>
            <p>
                <br />
            </p>
            <p>
                Cookies are small text files stored on your Internet browser. We and our third-party
                partners use cookies and similar tracking technologies to help us understand things
                like what web pages, features, or ads you view and what games you play. You can
                disable cookies, limit the types of cookies you allow, or set your browser to alert
                you when cookies are being sent. Please refer to guidance provided by your
                individual web browser if you'd like help in managing your cookie preferences. We
                also offer cookie consent tools in certain regions to help you manage your cookies.
            </p>
            <p>
                <br />
            </p>
            <p>
                We may use tracking pixels or clear GIFs to collect information about your use of
                our Services and your response to our marketing emails. We use Internet log files
                (which contain technical data such as your IP address) to monitor traffic on our
                Services, troubleshoot technical problems, detect and prevent fraud, and enforce our
                User Agreement. We currently do not respond to Do Not Track (DNT) signals. You may
                opt out of certain types of tracking on the web, including certain analytics and
                tailored advertising by changing the cookie settings in your browser or via our
                consent tools, as applicable.
            </p>
            <p>
                <br />
            </p>
            <p>
                We also use Analytics, Advertising, Anti-Cheat, and Anti-Fraud technologies in our
                Services. These technologies may utilize the same cookies or similar mechanisms as
                further described below.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>B. Analytics Technologies</p>
            <p>
                <br />
            </p>
            <p>
                We use internal and third-party analytics technologies to collect information about
                how you use our Services, your computer or device and the health of our Services.
            </p>
            <p>
                <br />
            </p>
            <p>
                For instance, we may collect and store data from your computer or device when you
                use our Services. This information includes technical and related information about
                your computer or device and operating and/or network systems (such as IP Address and
                device ID), information about your engagement with certain features, gameplay and
                usage statistics, system interactions and peripheral hardware for purposes described
                in Section 3 below. If you play a game offline without connecting to the Internet,
                this data will be stored on your device and transmitted to us when your device
                connects to the Internet. If you participate in online Services, we may also
                collect, use, store, transmit and publicly display your personal and/or statistical
                data regarding your game play (including scores, rankings and accomplishments), or
                identify content that is created and shared by you with other players.
            </p>
            <p>
                <br />
            </p>
            <p>
                Third-party analytics technologies integrated into our Services may (including SDK
                [Software Development Kit] and API [Application Program Interfaces] integrations)
                combine the information they collect in connection with your use of STREAMSIX's
                Services with information they have independently collected over time and/or across
                different platforms. Many of these companies collect and use information pursuant to
                their own privacy policies. A list of third-party analytics companies that operate
                in our Services as well as how to opt out to the extent applicable can be found at
                <a href="http://www.streamsix.com/privacy-appendix">
                    www.streamsix.com/privacy-appendix
                </a>
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>C. Ad Serving Technologies</p>
            <p>
                <br />
            </p>
            <p>
                Some of our Services employ ad serving technologies that use cookies, clear GIFs,
                web beacons, tracking pixels, SDK, API, and other similar technologies to deliver
                offers and advertising to you within STREAMSIX Services as well as on third-party
                platforms and sites, and to measure the performance of our advertising campaigns.
                Some of these technologies can sync or connect behavior across different websites,
                mobile apps and devices to tailor offers and advertising to your interests. For
                instance, you may be presented with an offer for a game we think you might enjoy.
                Or, if you express interest in a game, you may receive an advertisement later for
                that game or similar Services on STREAMSIX or third-party sites. Other in-game
                advertising technologies enable offers to be temporarily uploaded to your game, web
                browser, or mobile device and later replaced while you are online.
            </p>
            <p>
                <br />
            </p>
            <p>
                These technologies collect and use information so we can serve appropriate offers
                and advertising to you, to measure effectiveness and distribution of these offers
                and advertising, and to understand how users interact with our Services. In addition
                to identifiers and certain information listed in section 1(C) above, this
                information may include:
            </p>
            <p>
                <br />
            </p>
            <p>Advertisements served and the location of the ad;</p>
            <p>Length of time an advertisement was visible;</p>
            <p>Domain type, IP address, size of the advertisement;</p>
            <p>Your interaction, if any, with the ad; and</p>
            <p>Advertisement response.</p>

            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>D. Anti-Cheat and Fraud Prevention Technologies</p>
            <p>
                <br />
            </p>
            <p>
                We strive to provide a safe and fair gaming environment for all players. When you
                use our Services, we or third parties may use cookies and similar technologies and
                collect data about your machine or device, to create a machine "fingerprint" or
                "hash" of your machine components, for fraud prevention, security and authentication
                purposes. We may also monitor publicly available information, third-party sites,
                and/or use anti-cheat technology within our Services, including automated anti-fraud
                and abuse algorithms. If you believe your access to our games and/or Services was
                blocked by this technology in error, please contact STREAMSIX Help at
                <a href="mailto:help@streamsix.com">help@streamsix.com</a>.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>3. How We Use Your Information</p>
            <p>
                We use your information to operate our Services, to improve your game experience, to
                provide you customer support, to serve and measure the effectiveness of advertising,
                and to personalize our communications with you.
            </p>
            <p>
                <br />
            </p>
            <p>
                We use your personal information, both individually and combined together, in the
                following ways.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>
                To operate our business and to enhance and personalize your game experience,
                including to:
            </p>
            <p>
                <br />
            </p>
            <p>Operate, improve, and develop our games and Services;</p>
            <p>
                Undertake research and analysis to develop and demonstrate our technology, and to
                better understand our players;
            </p>
            <p>Populate online leaderboards and enable online matchmaking;</p>
            <p>Provide replays to you and other players via spectator modes;</p>
            <p>
                Help you find your friends or tell your friends about a STREAMSIX game or Service;
            </p>
            <p>Facilitate sharing on social networks;</p>
            <p>Manage and serve targeted and contextual advertising;</p>
            <p>
                Measure the effectiveness and distribution of advertising, including understanding
                who engages with our Services and how they interact with our Services;
            </p>
            <p>Measure the health of our Services;</p>
            <p>
                Detect security incidents, protect against malicious, deceptive, fraudulent or
                illegal activity, and prosecute those responsible for that activity;
            </p>
            <p>Set up and maintain accounts for which you register;</p>
            <p>Provide game experiences that you may like;</p>
            <p>Set up and facilitate loyalty programs;</p>
            <p>Facilitate your gameplay on multiple devices and/or platforms, as applicable;</p>
            <p>Identify, fix, and troubleshoot bugs or functionality errors;</p>
            <p>Provide software updates;</p>
            <p>Authenticate and activate your games and save game-play data, including progress;</p>
            <p>Facilitate competitions and contests;</p>
            <p>Perform audits, transactions, and other compliance activities;</p>
            <p>Adhere to your preferences and to deliver content;</p>
            <p>
                Help keep our Services safe and fair, resolve disputes, investigate and help curb
                fraud and illegal behavior, comply with the law, and to enforce our agreements and
                policies; and
            </p>
            <p>
                Other purposes you consent to, are notified of, or are otherwise disclosed to you
                when you provide personal information.
            </p>

            <p>
                <br />
            </p>
            <p>To provide you support, including to:</p>
            <p>
                <br />
            </p>
            <p>Help identify and troubleshoot problems with your account or Services;</p>
            <p>Facilitate surveys or questionnaires.</p>
            <p>Communicate with you and respond to your specific requests or questions; and</p>
            <p>
                Manage and send you confirmations and important information about your account,
                Services, purchases, subscriptions, and warranties.
            </p>

            <p>
                <br />
            </p>
            <p>To personalize our communications with you, including to:</p>
            <p>
                <br />
            </p>
            <p>
                Present offers and/or information relating to games and/or Services you might like;
            </p>
            <p>Make game or other Service recommendations to you; and</p>
            <p>Provide you with Service updates.</p>
            <p>
                We retain the information we collect for as long as necessary to provide our
                Services, and we may retain that information beyond that period if necessary for
                legal, operational, or other legitimate reasons.
            </p>
            <p>
                <br />
            </p>
            <p>
                We may also de-identify, anonymize, or aggregate the information we collect, or
                collect it in a way that does not directly identify you. We may use and share such
                information as necessary for our business purposes and as permitted by applicable
                law.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>4. Information We Share with Third Parties</p>
            <p>
                We do not disclose or share your personal information with third parties except as
                we describe in this section, such as to provide our Services and to deliver
                advertisements.
            </p>
            <p>
                <br />
            </p>
            <p>
                Except as described below, we do not share, sell, or otherwise disclose personal
                information to third parties (as these processing activities are defined under
                applicable privacy laws):
            </p>
            <p>
                <br />
            </p>
            <p>
                Service providers. We employ third parties located in and outside of your country of
                residence, to collect or process personal information on our behalf for the purposes
                described in Section 3. These purposes include conducting market surveys, providing
                IT and related services, facilitating credit card processing, facilitating live
                events, sending emails, or delivering and optimizing our Services. We require that
                any third party use the data only on our behalf and for purposes consistent with
                this policy.
            </p>
            <p>
                <br />
            </p>
            <p>
                Business partners. We may provide personal information to business partners with
                whom we jointly offer Services.
            </p>
            <p>
                <br />
            </p>
            <p>
                Disclosures to protect us or others. We may access, preserve, and disclose any
                information we store associated with you to external parties if we, in good faith,
                believe doing so is required or appropriate to: comply with law enforcement or
                national security requests and legal process, such as a court order or subpoena;
                protect your, our or others' rights, property, or safety; enforce our policies or
                contracts; collect amounts owed to us; or assist with an investigation or
                prosecution of suspected or actual illegal activity. In particular, if we receive a
                report that you have violated our policies , we may disclose that report and other
                relevant information to the platform on which you play our games.
            </p>
            <p>
                <br />
            </p>
            <p>
                Disclosure in the event of merger, sale, or other asset transfer. In the event of a
                reorganization, divestiture, merger, sale, or bankruptcy, we may transfer all
                information we collect to the relevant third party and will obtain your consent to
                do so if required by law or contract.
            </p>
            <p>
                <br />
            </p>
            <p>
                Third-party plugins. When third-party technologies or social tools are integrated
                into our Services, those third parties may collect information about your use of our
                Services. An example is the Facebook "Like" button.
            </p>
            <p>
                <br />
            </p>
            <p>
                Cross-Platform Sharing. Some of our games allow you to connect and play with friends
                and members of a game's community, regardless of what platform they play on. In such
                cases, that other platform may receive your platform's ID along with other
                information necessary.
            </p>
            <p>
                <br />
            </p>
            <p>
                With Your Consent. We may share information with other third parties with your
                express consent, unless otherwise described above. For example, you may agree to us
                sharing your information with a certain company or organization to hear about their
                products, services, or promotions, or if you tell us that you want to link your
                STREAMSIX Account with another company’s services. Use of the information you agree
                to share will be subject to those third parties' respective privacy notices.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>5. Where We Hold Your Information</p>
            <p>
                We store and process your information in Canada, The United States of America, and
                other countries where we may operate. When we do this, we utilize technical,
                physical, and administrative safeguards to meet data transfer requirements set by
                various privacy laws, such as the European General Data Protection Regulation.
            </p>
            <p>
                <br />
            </p>
            <p>
                Personal information we collect may be stored and processed for the purposes set out
                in this Privacy and Cookie Policy in the United States or any other country in which
                STREAMSIX or third-party agents operate. By consenting to the transfer of your
                personal data outside of your country of residence, you acknowledge that your
                personal information may be transferred to recipients in the United States and other
                countries that may not offer the same level of privacy protection as the laws in
                your country of residence or citizenship.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>6. How We Protect Your Information</p>
            <p>We use a range of security measures to secure and protect your information.</p>
            <p>
                <br />
            </p>
            <p>
                Security of your information is a priority at STREAMSIX and we take a range of
                technical and organizational measures to help protect it. Please be aware that no
                security measure is 100% perfect, thus we cannot always guarantee the security of
                your information. You should always be diligent when it comes to the protection of
                your personal information.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>7. Your Choices and Controls</p>
            <p>
                We provide you with choice and control about our use of your information, including
                your ability to exercise your data privacy rights.
            </p>
            <p>
                <br />
            </p>
            <p>
                We give you meaningful choices when it comes to our collection and use of your
                information. For example, if you no longer want to receive marketing emails from
                STREAMSIX, you may click the unsubscribe link included in the footer of any
                marketing email we send.
            </p>
            <p>
                <br />
            </p>
            <p>
                You can exercise any of your privacy rights by visiting our
                https://auth.streamsix.com/auth. To protect your account security and personal
                information, you may be asked to verify your account ownership. Once you have
                verified your account ownership, you may also be required to provide your
                confirmation authorizing an agent to exercise these rights on your behalf. If you
                have additional questions about exercising your privacy rights, you may contact us
                through privacy@streamsix.com.
            </p>
            <p>
                <br />
            </p>
            <p>
                Your right to deletion. You may delete your STREAMSIX Account and the personal
                information associated with your account through the account console at
                https://auth.streamsix.com/auth. If you do so, you will no longer have access to the
                STREAMSIX games or Services associated with your account. Note that STREAMSIX may
                retain information needed to resolve disputes, enforce our user agreements, protect
                our legal rights, and comply with technical and legal requirements and constraints
                related to the security, integrity and operation of our Services.
            </p>
            <p>
                <br />
            </p>
            <p>
                Your right to access. You can access the personal information we hold about you;
                please contact us using privacy@streamsix.com to request access to your personal
                data,
            </p>
            <p>
                <br />
            </p>
            <p>
                Your right to correction. You can request correction of your personal information
                where it is inaccurate by emailing your request to privacy@streamsix.com
            </p>
            <p>
                <br />
            </p>
            <p>
                Your right to opt out or object to certain processing. You may have the right to opt
                out of disclosing, sharing, or selling your personal information to third parties,
                if applicable, or object to some processing of your data, where such requests are
                permitted by law.
            </p>
            <p>
                <br />
            </p>
            <p>
                Do Not Sell My Personal Information. You have the right to opt-out of selling your
                personal information to third parties. Once we receive and confirm a verifiable
                consumer request form from you, we will stop selling your personal information.
            </p>
            <p>
                <br />
            </p>
            <p>To exercise your rights to opt-out, please contact us at privacy@streamsix.com</p>
            <p>
                <br />
            </p>
            <p>
                You also may adjust your browser settings to block certain online tracking
                technologies, such as cookies, as described in Section 2(A).
            </p>
            <p>
                <br />
            </p>
            <p>
                You have a right not to receive discriminatory treatment for the exercise of these
                privacy rights.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>8. Third-Party Services</p>
            <p>
                Our websites and Services may contain ads or links to third-party services and
                sites.
            </p>
            <p>
                <br />
            </p>
            <p>
                Our websites and Services may contain advertising or links to third-party services.
                If you click on those links, including an advertisement, you will leave the Service
                and go to the third-party service or site that you selected. If you visit a
                third-party website or use a third-party service, you should consult that service's
                or site's privacy policy as your use of third-party sites or services is governed by
                their privacy policies.
            </p>
            <p>
                <br />
            </p>

            <p>
                <br />
            </p>
            <p>9. Changes to Our Policy</p>
            <p>
                This policy will be updated from time to time and we will notify you of material
                changes.
            </p>
            <p>
                <br />
            </p>
            <p>
                We may occasionally update this privacy policy. When we do, we will revise the "last
                updated" date at the bottom of the policy.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>10. Contact Us</p>
            <p>You may contact us if you have questions about this policy.</p>
            <p>
                <br />
            </p>
            <p>
                If you have questions about this policy, please email privacy@streamsix.com to
                contact our Data Protection Officer.
            </p>
            <p>Or mail us a request to:</p>
            <p>Attention: Data Protection Officer</p>
            <p>STREAMSIX</p>
            <p>Unit 400, 49 Bathurst Street</p>
            <p>Toronto, ON</p>
            <p>M5V 2P2</p>

            <p>
                <br />
            </p>
            <p>11. Right to Contact a Data Protection Authority</p>
            <p>You have the right to contact your Data Protection Authority.</p>
            <p>
                In Canada you can find details on how to reach the Office of the Privacy
                Commissioner of Canada here:{' '}
                <u>
                    <Link href="https://priv.gc.ca" isExternal>
                        priv.gc.ca
                    </Link>
                </u>
            </p>
            <p>
                <br />
            </p>
            <p>Last Updated: September 19, 2023</p>
        </Flex>
    );

    return (
        <>
            <BrowserView>
                <BrowserTopBar color="#FFF" isLoading={false}>
                    <Box className={'settings-title browser-view-title'}>
                        <Text>PRIVACY</Text>
                    </Box>
                </BrowserTopBar>
                <BrowserSidebar />
                <Flex className={'browser-content'}>{renderContent()}</Flex>
            </BrowserView>
            <MobileViewPage
                title="PRIVACY"
                titleColor="#FFF"
                titleBackgroundColor="#6867dd"
                isLoading={false}
            >
                <Flex className={'privacy-mobile'}>{renderContent()}</Flex>
            </MobileViewPage>
        </>
    );
};
